'use client';

import clsx from 'clsx';
import { FC, PropsWithChildren, useContext, useRef } from 'react';
import AlgonomyContext, { AlgonomyContextState } from '@/context/SearchResultsContext';
import Backdrop from '@/components/Backdrop';
import BaseButton from '@/components/Button/BaseButton';
import useClickOutSide from '@/hooks/useClickOutside';

import { FilterItemsServerProps } from './types';
import styles from './FilterItemsServer.module.css';

const FilterItemsServer: FC<PropsWithChildren<FilterItemsServerProps>> = ({ children, applyButtonLabel }) => {
  const filterItemsRef = useRef<HTMLDivElement>(null);
  const { openFilter, mobile, handleOnClickOutside, handleApplyFilters } = useContext(
    AlgonomyContext,
  ) as AlgonomyContextState;

  useClickOutSide(filterItemsRef, handleOnClickOutside);

  const renderFilterItems = () => (
    <>
      {mobile && openFilter && <Backdrop className={styles.filterItemsBackdrop} />}
      <aside
        className={clsx(styles.filtersList, {
          [styles.filtersListActive]: openFilter,
          [styles.filtersListAnimate]: openFilter,
        })}
        ref={filterItemsRef}
      >
        {children}
        <div className={`${styles.applyFilters} ${styles.shadowFilter}`}>
          <BaseButton id={'filter-apply-button'} classes={styles.applyButton} label={applyButtonLabel} onClick={handleApplyFilters} />
        </div>
      </aside>
    </>
  );
  return <>{mobile ? openFilter && renderFilterItems() : renderFilterItems()}</>;
};

export default FilterItemsServer;
